<template>
    <el-select v-model="value">
      <el-option 
        v-for="item in subjectData" 
        :key="item.id" 
        :value="item.id"
        :label="item.name"
      ></el-option>
    </el-select>
</template>

<script>
export default {
  name: 'Subject',
  data() {
    return {
      subjectData: [],
      value: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.mixin_getSelectSubject().then(data => {
        this.subjectData = data
      })
    }
  }
}
</script>

<style>

</style>